import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '../button';
import { CIRCLE_ICON } from '../button/variants';
import { Guide } from '../../helpers/icon-dictionary';
import css from './index.scss';

const ItemSelector = (props) => {
    const { selected, css: propsCss, guideUrl, hasNoCursor, hasGuide } = props;
    const styles = { ...css, ...propsCss };

    // Selected class
    const selectedClassName = selected ? styles.selected : '';

    const cursorClassName = hasNoCursor ? styles.noCursor : '';

    // delete CSS props passing down to Button
    const buttonProps = props;
    delete buttonProps.css;

    const viewButton = hasGuide ? (<Button
        containerClassName={`${styles.button}`}
        handleOnClick={() => { window.open(guideUrl, '_blank'); }}
        icon={Guide}
        variant={CIRCLE_ICON} />) : '';

    return (<div className={`${styles.itemSelector} ${selectedClassName}`}>
        <Button containerClassName={`${styles.label}  ${cursorClassName}`} {...buttonProps} />
        {viewButton}
    </div>);
};

ItemSelector.propTypes = {
    /**
     * CSS overrides please refer to React-Styleable
     */
    css: PropTypes.object,
    /**
     * Toggle to show guide or preview button
     */
    guideUrl: PropTypes.string,
    /**
     * Toggle to show guide or preview button
     */
    hasGuide: PropTypes.bool,
    /**
     * Hide cursor upon hover
     */
    hasNoCursor: PropTypes.bool,
    /**
     * Toggle to show different style when cliced or selected
     */
    selected: PropTypes.bool
};

export default injectIntl(ItemSelector);



// WEBPACK FOOTER //
// ./app/components/course-topics-details/item-selector.js